import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { socialLinks } from './navData';
export function TopBar() {
  return <div className="bg-brand-gray-900 border-b border-brand-gray-800 hidden md:block" data-id="element-131">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="flex justify-between items-center h-9" data-id="element-133">
          <div className="flex items-center gap-4" data-id="element-134">
            <a href="tel:18666343373" className="flex items-center gap-1.5 text-xs text-brand-gray-400 hover:text-brand-teal transition-colors" data-id="element-135">
              <Phone className="w-3 h-3" data-id="element-136" />
              1-866-634-3373
            </a>
            <span className="w-px h-3 bg-brand-gray-700" data-id="element-137" />
            <a href="mailto:info@apc360zone.com" className="flex items-center gap-1.5 text-xs text-brand-gray-400 hover:text-brand-teal transition-colors" data-id="element-138">
              <Mail className="w-3 h-3" data-id="element-139" />
              info@apc360zone.com
            </a>
          </div>
          <div className="flex items-center gap-3" data-id="element-140">
            {socialLinks.map(social => <a key={social.label} href={social.href} target="_blank" rel="noreferrer" aria-label={social.label} className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-141">
                <social.icon className="w-3.5 h-3.5" data-id="element-142" />
              </a>)}
          </div>
        </div>
      </div>
    </div>;
}